<template>
  <div class="main-menu menu-fixed menu-light menu-accordion menu-shadow app-sidebar" data-scroll-to-active="true">

    <!-- Top bar: brand + close -->
    <div class="sidebar-topbar">
      <span class="sidebar-brand-text">Medicater</span>
      <a class="close-navbar sidebar-close-btn" @click.prevent="closeSidebar"><i class="ft-x"></i></a>
    </div>

    <!-- User profile card -->
    <div class="sidebar-profile">
      <div class="profile-avatar">{{ userInitial }}</div>
      <div class="profile-info">
        <div class="profile-name">{{ userName }}</div>
        <div class="profile-merchant">{{ merchantName }}</div>
      </div>
    </div>

    <!-- Nav body -->
    <div class="main-menu-content sidebar-body">

      <p class="sidebar-section-label">Main Menu</p>
      <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
        <li class="nav-item">
          <router-link to="/" exact>
            <span class="nav-icon-bubble" style="-:#3b82f6"><i class="ft-home"></i></span>
            <span class="menu-title">Home</span>
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link to="/unconfirmed">
            <span class="nav-icon-bubble"><i class="ft-plus-circle"></i></span>
            <span class="menu-title">Place New Order</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/ward">
            <span class="nav-icon-bubble"><i class="ft-edit"></i></span>
            <span class="menu-title">Review / Edit Orders</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/feedback">
            <span class="nav-icon-bubble"><i class="ft-clipboard"></i></span>
            <span class="menu-title">Feedback</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/messages">
            <span class="nav-icon-bubble"><i class="ft-message-square"></i></span>
            <span class="menu-title">Messages</span>
          </router-link>
        </li> -->
      </ul>

      <!-- <p class="sidebar-section-label">Support</p> -->
      <ul class="navigation navigation-main">
        <li class="nav-item">
          <router-link to="/contact">
            <span class="nav-icon-bubble"><i class="ft-mail"></i></span>
            <span class="menu-title">Contact Us</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/faq">
            <span class="nav-icon-bubble"><i class="ft-help-circle"></i></span>
            <span class="menu-title">FAQ</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/about">
            <span class="nav-icon-bubble"><i class="ft-info"></i></span>
            <span class="menu-title">About Us</span>
          </router-link>
        </li>
        <li class="nav-item" v-if="user.merchant.enable_print_from_device == 'Y'">
          <router-link to="/printer">
            <span class="nav-icon-bubble"><i class="ft-printer"></i></span>
            <span class="menu-title">Printer Settings</span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- Footer -->
    <div class="sidebar-footer">
      <a href="#" class="sidebar-logout" v-on:click.prevent="logout()">
        <span class="nav-icon-bubble"><i class="ft-power" style="padding-top: 0px !important"></i></span>
        <span>Log Out</span>
      </a>
    </div>

    <div class="navigation-background"></div>
  </div>
</template>

<script>
export default {
  name: 'appLayout',
  data: function () {
    return {
      user: JSON.parse(window.localStorage.getItem('user'))
    }
  },
  computed: {
    userName: function () {
      var u = this.user
      if (!u) return 'User'
      return u.name || u.full_name || u.username || window.localStorage.getItem('username') || 'User'
    },
    userInitial: function () {
      return (this.userName || 'U').charAt(0).toUpperCase()
    },
    merchantName: function () {
      var u = this.user
      return (u && u.merchant && u.merchant.name) ? u.merchant.name : ''
    }
  },
  mounted: function () {
    $('.navigation li').on('click', function () {
      $('body').removeClass('menu-open').addClass('menu-hide')
    })
    this.user = JSON.parse(window.localStorage.getItem('user'))
  },
  methods: {
    closeSidebar: function () {
      $('body').removeClass('menu-open').addClass('menu-hide')
    },
    logout: function () {
      console.log("Logging out...")
      var that = this
      localStorage.clear()

      try {
        if (window.plugins && window.plugins.imeiGetter) {
          window.plugins.imeiGetter.get(function (imei) {
            window.localStorage.setItem('imei', imei)
          }, function () {
            window.localStorage.setItem('imei', '')
          })
        }
        if (typeof device !== 'undefined') {
          window.localStorage.setItem('uuid', device.uuid)
          window.localStorage.setItem('version', device.version)
          window.localStorage.setItem('device_name', device.manufacturer + ' ' + device.model)
        }
      } catch (e) {
        console.warn('Device plugin unavailable', e)
      }

      that.$router.push('/login')
    }
  }
}
</script>

<style scoped>
/* ── Shell ── */
.app-sidebar {
  background: #05aceb !important;
      box-shadow: 4px 0 32px rgb(0 0 0 / 0%) !important;
  display: flex !important;
  flex-direction: column !important;
}

/* ── Top bar ── */
.sidebar-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 14px;
  position: relative;
  z-index: 3;
}

.sidebar-brand-text {
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  background: linear-gradient(90deg, #ffffff 0%, #5eead4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sidebar-close-btn {
  color: rgba(255, 255, 255, 0.4) !important;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  font-size: 0.95rem;
}

.sidebar-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff !important;
}

/* ── Profile card ── */
.sidebar-profile {
      display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    gap: 12px;
    /* margin: 0 12px 16px; */
    padding: 14px 14px;
    background: #17567f;
    border: 1px solid rgba(255, 255, 255, 0.08);
    /* border-radius: 14px; */
    position: relative;
    z-index: 3;
       height: 80px;
}

.profile-avatar {
     width: 42px;
    height: 42px;
    border-radius: 12px;
    background: #ffff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 1.1rem;
    font-weight: 700;
    color: #17567f;
    -ms-flex-negative: 0;
    flex-shrink: 0;
}

.profile-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  font-weight: 900;
}

.profile-merchant {
  font-size: 0.75rem;
  color: #eee;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

/* ── Section labels ── */
.sidebar-section-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: white;
  padding: 16px 18px 6px;
  margin: 0;
}

/* ── Body ── */
.sidebar-body {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 8px;
  position: relative;
  z-index: 3;
}

/* ── Nav items ── */
.app-sidebar .navigation-main > li > a {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 7px 10px 7px 12px !important;
  margin: 2px 10px !important;
  color: white !important;
  text-decoration: none !important;
  border-radius: 10px !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  transition: background 0.15s, color 0.15s !important;
  border: none !important;
}

.app-sidebar .navigation-main > li > a:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #fff !important;
}

.app-sidebar .navigation-main > li > a.router-link-active {
     background: #17567f !important;
    color: #f6fffe !important;
}

/* ── Icon bubble ── */
.nav-icon-bubble {
  width: 32px;
  height: 32px;
  border-radius: 8px;
      background: 
color-mix(in srgb, #265b75 18%, #fb5653);
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  color: var(--ic) !important;
  transition: background 0.15s;
}

.nav-icon-bubble i {
  display: block;
  font-size: 0.875rem;
  line-height: 1;
  width: 1em;
  height: 1em;
  margin: 0;
  padding: 0;
  padding-top: 10px;
}

.app-sidebar .navigation-main > li > a:hover .nav-icon-bubble {
  background: color-mix(in srgb, var(--ic) 28%, transparent);
}

/* ── Footer ── */
.sidebar-footer {
  padding: 10px 10px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  position: relative;
  z-index: 3;
}

.sidebar-logout {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 7px 10px !important;
  margin: 0 2px !important;
  border-radius: 10px !important;
  color: rgba(255, 255, 255, 0.65) !important;
  text-decoration: none !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  transition: background 0.15s, color 0.15s !important;
}

.sidebar-logout:hover {
  background: rgba(220, 38, 38, 0.12) !important;
  color: #fca5a5 !important;
}

.sidebar-logout span:last-child {
  color: inherit;
}
</style>

<!-- Global: shared page-header styles -->
<style>
.back-btn {
  background: #fb5653 !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}
.back-btn:hover {
  background: #e03e3b !important;
}
</style>

<!-- Force overlay-only sidebar on all screen sizes -->
<style>
body.app-layout .main-menu {
  width: 300px !important;
  min-width: 300px !important;
  left: -300px !important;
  opacity: 0 !important;
  -webkit-transform: translate3d(0, 0, 0) !important;
          transform: translate3d(0, 0, 0) !important;
  -webkit-transition: opacity .25s, -webkit-transform .25s !important;
          transition: opacity .25s, transform .25s !important;
}
body.app-layout.menu-open .main-menu {
  opacity: 1 !important;
  -webkit-transform: translate3d(300px, 0, 0) !important;
          transform: translate3d(300px, 0, 0) !important;
}
body.app-layout .navbar .navbar-container,
body.app-layout .header-navbar .navbar-container,
body.app-layout .app-content.content {
  margin-left: 0 !important;
}
body.app-layout .page-header {
  padding-left: 1em !important;
}
</style>

